/**
 * Real briefing API — calls gi-api-server endpoints.
 *
 * - GET  /api/v1/omega/briefing/today
 * - GET  /api/v1/omega/briefing/history?days=N
 */

import type { BriefingHistoryResponse, FounderBriefing } from '../types';
import { apiFetch } from '../http';

export async function getBriefingToday(): Promise<FounderBriefing> {
  return apiFetch<FounderBriefing>('/omega/briefing/today');
}

export async function getBriefingHistory(days = 7): Promise<BriefingHistoryResponse> {
  return apiFetch<BriefingHistoryResponse>(`/omega/briefing/history?days=${days}`);
}
